"use client";

import Link from "next/link";
import Image from "next/image";
import { ArrowRight, ChevronDown } from "lucide-react";
import { useState, useRef } from "react";

type Industry = {
  title: string;
  product: string;
  productLogo: string;
  href: string;
  features: string[];
  image: string; // optional machen
};

const industries: Industry[] = [
  {
    title: "Einzelhandel – Brautmode",
    product: "",
    productLogo: "./CTXr.svg",
    href: "/kassensysteme/brautmode",
    image: "/industries/Brautmode.webp",
    features: [
      "Schneller und intuitiver Kassiervorgang im Alltag",
      "Schnelle Konfiguration von Schnelltasten",
      "Terminbasierte Beratung & Anproben direkt im System",
      "Anzahlungen & Restzahlungen pro Auftrag verwalten",
      "Änderungen & Maßanpassungen mit Statusverfolgung",
      "Individuelle Aufträge mit Kundenwünschen und Notizen",
      "Kundenkartei mit Maßen, Vorlieben und Bestellhistorie",
      "Übersicht offener Aufträge und ausstehender Abholungen",
      "Lieferantenverwaltung für Bestellungen bei Designern",
      "Größen- und Farbmatrix für Brautkleider und Accessoires",
    ],
  },
  {
    title: "Einzelhandel – Getränke",
    product: "",
    productLogo: "./CTXr.svg",
    href: "/kassensysteme/getraenke",
    image: "/industries/Getraenkehandel.webp",
    features: [
      "Schneller und intuitiver Kassiervorgang im Alltag",
      "Schnelle Konfiguration von Schnelltasten",
      "Pfandverwaltung ohne manuelles Nachrechnen",
      "Kisten- und Leergutprozesse direkt im Verkauf integriert",
      "Schnelle Mengenauswahl für typische Verkaufsabläufe",
      "Barcode-optimierte Abläufe für hohe Geschwindigkeit an der Kasse",
      "Automatische Lagerbestandsüberwachung mit Mindestmengen",
      "Lieferantenverwaltung für schnelle Nachbestellungen",
      "Übersicht über meistverkaufte Artikel und Umsatz pro Kategorie",
      "Kassenjournal und GoBD-konforme Archivierung",
    ],
  },
  {
    title: "Einzelhandel – Friseur & Kosmetik",
    product: "",
    productLogo: "./CTXr.svg",
    href: "/kassensysteme/friseur-kosmetik",
    image: "/industries/friseur.webp",
    features: [
      "Schneller und intuitiver Kassiervorgang im Alltag",
      "Schnelle Konfiguration von Schnelltasten",
      "Mitarbeiterzuweisung, Umsatzstatistik & Provisionsabrechnung",
      "Dienstleistungen und Produkte in einem Vorgang kombinieren",
      "Trinkgeld und Provisionen automatisch berücksichtigt",
      "Kundenkartei mit Behandlungshistorie und Vorlieben",
      "Schneller und intuitiver Kassiervorgang",
      "Gutscheinverkauf und -einlösung direkt an der Kasse",
      "Erinnerungen und Wiedervorlagen für Stammkunden",
    ],
  },
  {
    title: "Einzelhandel – Textil",
    product: "",
    productLogo: "./CTXr.svg",
    href: "/kassensysteme/textil",
    image: "/industries/hero.webp",
    features: [
      "Schneller und intuitiver Kassiervorgang im Alltag",
      "Schnelle Konfiguration von Schnelltasten",
      "Größen- und Farbmatrix für Textilartikel",
      "Saisonverwaltung für Kollektionen",
      "Flexible Zahlungsarten und Belegausgabe",
      "Klare Auswertungen für bessere Entscheidungen",
      "Kundenverwaltung mit Kaufhistorie",
      "Übersichtliche Artikel- und Lagerverwaltung",
      "Automatische Lagerbestandsüberwachung mit Mindestmengen",
    ],
  },
  {
    title: "Einzelhandel – Schuhe",
    product: "",
    productLogo: "./CTXr.svg",
    href: "/kassensysteme/schuhe",
    image: "/industries/cashtex_schuhe.webp",
    features: [
      "Schneller und intuitiver Kassiervorgang im Alltag",
      "Schnelle Konfiguration von Schnelltasten",
      "Größenverwaltung pro Artikel und Marke",
      "Übersichtliche Lagerübersicht nach Größe und Modell",
      "Flexible Zahlungsarten und Belegausgabe",
      "Klare Auswertungen für bessere Entscheidungen",
      "Kundenverwaltung mit Kaufhistorie",
      "Automatische Lagerbestandsüberwachung mit Mindestmengen",
      "Saisonverwaltung für Kollektionen",
    ],
  },
  {
    title: "Einzelhandel – Second-Hand",
    product: "",
    productLogo: "./CTXr.svg",
    href: "/kassensysteme/secondhand",
    image: "/industries/highlight.webp",
    features: [
      "Schneller und intuitiver Kassiervorgang im Alltag",
      "Schnelle Konfiguration von Schnelltasten",
      "Kommissionsabrechnung für Lieferanten direkt im System integriert",
      "Automatische Abrechnungen und Auszahlungen ohne manuelle Berechnung",
      "Verwaltung und Abrechnung von Regalflächen und Mietverträgen",
      "Jeder Artikel als Einzelstück mit individueller Preis- und Zustandslogik",
      "Etiketten- und Barcode-Druck direkt aus der Artikelerfassung",
      "Unterstützung von Spezialbarcodes (z. B. Gewicht oder individuelle Kennzeichnung)",
      "Zustandsbewertung und Kategorisierung gebrauchter Artikel",
      "Übersicht offener Kommissionsabrechnungen pro Einlieferer",
    ],
  },
  {
    title: "Großhandel",
    product: "",
    productLogo: "./modeprofi.svg",
    href: "/modeprofi",
    image: "/index/products/modeprofi.webp",
    features: [
      "Schneller und intuitiver Kassiervorgang im Alltag",
      "Schnelle Konfiguration von Schnelltasten",
      "Individuelle Preislisten pro Kunde oder Kundengruppe",
      "B2B Bestellprozesse ohne Medienbrüche",
      "Mengenstaffeln direkt im Verkauf berücksichtigt",
      "Schnelle Nachbestellung und Wiederholaufträge",
      "Größen- und Farbmatrix für Textilartikeln",
      "Saisonverwaltung für Kollektionen",
      "Automatische Lagerbestandsüberwachung mit Mindestmengen",
      "DATEV-Export für nahtlose Buchhaltungsübergabe",
    ],
  },
  {
    title: "Messe & Eventverkauf",
    product: "",
    productLogo: "./officefortrade.svg",
    href: "/office4trade",
    image: "/industries/messee.webp",
    features: [
      "Schneller und intuitiver Kassiervorgang im Alltag",
      "Schnelle Konfiguration von Schnelltasten",
      "Offlinefähig auch bei instabiler Internetverbindung",
      "Optimierte Bedienung für Stoßzeiten",
      "Unterteilung und Verwaltung von mehreren Firmen möglich",
      "Minimaler Setup-Aufwand direkt vor Ort",
      "Schneller Standwechsel zwischen verschiedenen Messeorten",
      "Mehrere Kassen parallel auf einem Event betreibbar",
      "Übersichtliche Artikelkacheln für schnelles Tippen",
      "Tagesabschluss mit exportierbarem Kassenbericht",
    ],
  },
];

export default function SpecialFeaturesOverview() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 px-6 max-w-6xl mx-auto">
      <div className="mb-16 text-center">
        <h2 className="text-3xl md:text-4xl font-semibold mb-4">
          Spezielle Funktionen für jede Branche
        </h2>
        <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto">
          Jede Branche hat eigene Anforderungen. Unsere Lösungen sind darauf
          ausgelegt, genau diese im Alltag abzubilden.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {industries.map((industry, index) => {
          const isOpen = openIndex === index;
          const preview = industry.features.slice(0, 2);

          return (
            <div
              key={index}
              className="border rounded-2xl overflow-hidden transition-all hover:shadow-md bg-white shadow-sm"
            >
              {/* BILD */}
              <div className="relative h-48 w-full">
                <Image
                  src={industry.image}
                  alt={industry.title}
                  fill
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="object-cover"
                />
              </div>

              {/* INHALT */}
              <div className="p-6 md:p-7 flex flex-col h-[calc(100%-12rem)]">
                {" "}
                {/* h-48 vom Bild sind 12rem */}
                {/* Dieser div umschließt alles AUẞER die Action Row und drückt sie nach unten */}
                <div className="grow">
                  {/* TITLE */}
                  <h3 className="text-xl font-semibold mb-4 flex items-center gap-3">
                    {industry.title}
                    <Image
                      src={industry.productLogo}
                      alt={industry.product}
                      width={80}
                      height={24}
                      className="object-contain"
                    />
                  </h3>

                  {/* PREVIEW & EXPAND */}
                  <div className="min-h-20">
                    {" "}
                    {/* Verhindert das Hüpfen bei 1 vs 2 Zeilen Text */}
                    {!isOpen && (
                      <ul className="space-y-2 text-base font-medium mb-4">
                        {preview.map((f, i) => (
                          <li key={i} className="line-clamp-2">
                            ✓ {f}
                          </li>
                        ))}
                      </ul>
                    )}
                    <div
                      ref={(el) => {
                        contentRefs.current[index] = el;
                      }}
                      style={{
                        height: isOpen
                          ? contentRefs.current[index]?.scrollHeight + "px"
                          : "0px",
                      }}
                      className="overflow-hidden transition-all duration-300 ease-in-out"
                    >
                      <ul className="space-y-3 text-base font-medium mb-4 pt-2">
                        {industry.features.map((f, i) => (
                          <li key={i}>✓ {f}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                {/* ACTION ROW - Durch mt-auto immer ganz unten */}
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-50">
                  <button
                    onClick={() => toggle(index)}
                    className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition"
                  >
                    {isOpen ? "Weniger" : "Details"}
                    <ChevronDown
                      size={16}
                      className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
                    />
                  </button>

                  <Link
                    href={industry.href}
                    className="flex items-center gap-2 text-primary font-semibold group"
                  >
                    <span>Mehr erfahren</span>
                    <ArrowRight className="transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
